// @flow

import { RECEIVED_SOCIAL_SETTINGS, RECEIVED_SOCIAL_LABEL_SETTINGS } from './constants';
import type { ReceivedSocialSettings } from './actions';
import type { SocialState } from './types';

const initialState: SocialState = {
  default: {
    twitter: '',
    facebook: '',
    instagram: '',
  },
};

export type State = SocialState;

export default (state: State = initialState, action: ReceivedSocialSettings): State => {
  switch (action.type) {
    case RECEIVED_SOCIAL_SETTINGS:
      return {
        ...state,
        default: {
          ...action.payload,
        },
      };
    case RECEIVED_SOCIAL_LABEL_SETTINGS:
      return {
        ...state,
        [action.label]: {
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
